import React from 'react';
import {Helmet} from 'react-helmet-async';
import AuthPageWithEmail from 'app/routes/AuthPageWithEmail';

const LoginWithEmailPage = () => {
  const props = {
    type: 'login',
    headline: 'Mit deinem Konto anmelden',
    subtitle: 'Willkommen zurück',
    backToOptionsText: 'Alle Anmeldeoptionen',
    backToOptionsLink: '/auth/login',
  };
  const meta = [{name: 'description', content: 'Melde dich bei deinem FuPa-Konto an und präsentiere deinen Verein.'}];
  return (
    <>
      <Helmet title='Login' meta={meta}>
        <link rel='canonical' href='https://www.fupa.net/auth/login' />
      </Helmet>
      <AuthPageWithEmail {...props} />
    </>
  );
};

export default LoginWithEmailPage;
